import { gql } from '@apollo/client'

/** 消息通知： 消息列表 */
export const GET_MESSAGE_NOTICE_LIST = gql`
  query msgList(
    $first: Int
    $offset: Int
    $type: BaseMsgType
    $version: MsgCenterVersion = V2
  ) {
    msgList(
      page: { first: $first, offset: $offset }
      baseMsgType: $type
      v: $version
    ) {
      edges {
        node {
          content
          id
          title
          baseMsgTypeStr(v: $version)
          baseMsgType(v: $version)
          type
          weblink
          time
          operatorAvatar: fromAvatar
          operatorName: fromName
          operatorId: fromId
          fromUserInfo {
            base {
              uid
            }
            userRoleInfo {
              artist
              aiArtist
            }
            social {
              followStatus
            }
            memberDetail {
              hold
            }
          }
          cl {
            jumpId
            jumpType
            photo
          }
        }
      }
      pageInfo {
        totalCount
        hasNextPage
      }
    }
  }
`

/** 获取未读消息总数 */
export const GET_UNREAD_MESSAGE_TOTAL_COUNT = gql`
  query getUnreadTotalCount(
    $notNeed: [BaseMsgType]
    $skipShield: Boolean
    $version: MsgCenterVersion = V2
  ) {
    count: unreadCount(notNeed: $notNeed, skipShield: $skipShield, v: $version)
  }
`
/** 未读消息列表 */
export const GET_UNREAD_MESSAGE_COUNT_LIST = gql`
  query getUnreadMessageCountList($version: MsgCenterVersion = V2) {
    unreadCountList(v: $version) {
      baseMsgType
      count
      showName
      iconUrl
      msg {
        content
        id
        title
        type
        time
      }
      shield
    }
  }
`

/** 阅读单个类型消息 */
export const READ_MESSAGE = gql`
  mutation readMessage($type: BaseMsgType) {
    status: readInteractionAll(baseMsgType: $type)
  }
`

/** 屏蔽/取消屏蔽消息 */
export const SET_SHIELD_STATUS = gql`
  mutation setShieldingStatus($type: BaseMsgType!, $status: Boolean!) {
    status: setShieldingStatus(baseMsgType: $type, status: $status)
  }
`
/** 一键已读所有消息 */
export const READ_ALL_MESSAGE = gql`
  mutation readAllMessage($version: MsgCenterVersion = V2) {
    status: newReadAll(v: $version)
  }
`
